import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-12948046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_list, {
      "item-layout": "vertical",
      size: "large",
      grid: { gutter: 20, column: 3 },
      "data-source": _ctx.data
    }, {
      renderItem: _withCtx(({ item }) => [
        _createVNode(_component_router_link, {
          to: '/doc?ebookId=' + item.id,
          slots: "a",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              style: {"height":"180px","margin":"5px"},
              bordered: true,
              hoverable: true,
              class: "card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_list_item, { key: "item.title" }, {
                  actions: _withCtx(() => [
                    _createElementVNode("span", null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent('FileOutlined'), { style: {"margin-right":"8px"} })),
                      _createTextVNode(" " + _toDisplayString(item.docCount), 1)
                    ]),
                    _createElementVNode("span", null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent('UserOutlined'), { style: {"margin-right":"8px"} })),
                      _createTextVNode(" " + _toDisplayString(item.viewCount), 1)
                    ]),
                    _createElementVNode("span", null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent('LikeOutlined'), { style: {"margin-right":"8px"} })),
                      _createTextVNode(" " + _toDisplayString(item.voteCount), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_list_item_meta, null, {
                      title: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: '/doc?ebookId=' + item.id,
                          slots: "a",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      avatar: _withCtx(() => [
                        _createVNode(_component_a_avatar, {
                          src: item.coverUrl
                        }, null, 8, ["src"])
                      ]),
                      description: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(item.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      _: 1
    }, 8, ["data-source"])
  ]))
}